export enum InvoicePaymentMethodEnum {
  creditCard = 'CREDIT_CARD',
  achCreditTransfer = 'ACH_CREDIT_TRANSFER',
  cash = 'CASH',
  check = 'CHECK',
}
